module.exports = __webpack_public_path__ + "static/media/snf.5523261d.jpg";